import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import RollPressPage from "../pages/roll-press/page";
import ServoHydraulicPage from "../pages/servo-hydraulic/page";
import ServoValvePage from "../pages/servo-valve/page";
import ExplosionProofServoMotorPage from "../pages/explosion-proof-servo-motor/page";
import ProductsPage from "../pages/products/page";
import EngineeringPage from "../pages/engineering/page";
import CompanyPage from "../pages/company/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/roll-press", element: <RollPressPage /> },
  { path: "/servo-hydraulic", element: <ServoHydraulicPage /> },
  { path: "/servo-valve", element: <ServoValvePage /> },
  { path: "/explosion-proof-servo-motor", element: <ExplosionProofServoMotorPage /> },
  { path: "/products", element: <ProductsPage /> },
  { path: "/engineering", element: <EngineeringPage /> },
  { path: "/company", element: <CompanyPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
